import { eShowTiFo, eTlfItemType } from "functions/api/enums";
import { createContext } from "react";
import { IMosaicTocExpanded, TocContextProps } from "./toc/interface";

export const defaultTocState: IMosaicTocExpanded = {
  blocked: false,
  changed: false,
  hierarchyId: "",
  readOnly: true,
  receivedMessages: [],
  removedItems: [],
  saving: false,
  saveError: false,
  searchText: "",
  sendUpdate: false,
  showTypes: Object.values(eTlfItemType),
  showTiFo: eShowTiFo.ToC,
  tocItems: [],
  commentsFilter: "all",
  lastMinorVersionSavedAt: null,
  lastMajorVersionSavedAt: 0,
};

export const TocContext = createContext<TocContextProps>({
  state: defaultTocState,
  dispatch:
    // istanbul ignore next
    () => {},
  tocRequest: { requesting: false, error: false },
});
